import {
  ILiveVodPageGrid,
  IPageMeta,
  isAdvertisers,
  isBanner,
  isBase,
  isCategoryOpener,
  isCategoryOpenerExtended,
  isContestantsComponent,
  isHorizontalNewsFlashes,
  isIFrameBlock,
  IsImageCounterComponent,
  isLayout3,
  isLayout4,
  isLayout6,
  isLayout7,
  isLiveBlock,
  isLiveBroadcast,
  isMainStandardItem,
  isMainTextOverItem,
  isMatrix1x4,
  isMatrix2x4,
  isMidBoxMobile,
  isMinuteLyTopVideoComponent,
  IsMinuteLyVerticalComponent,
  isOpinion,
  isPager,
  isPublishersComponent,
  isSeparator,
  isSpecialRef,
  isSpecialRefVotes,
  isTermHeadBlock,
  IsTerrificComponent,
  isTimeline,
  isTimeLineVerticalPlayerComponent,
  isVerticalBlock,
  IsVideoGridComponent,
  isVod,
  PageGridItem,
} from '../../types'
import { IFrame, LiveBroadcast } from '../../components/Main'
import LayoutWithBanner from '../../components/Layout/LayoutWithBanner'
import { Layout4, Layout6 } from '../../components/Layout'
import { Matrix1x4, Matrix2x4 } from '../../components/Matrix'
import { Publishers } from '../../components/Publishers/Publishers'
import { Contestants } from '../../components/Contestants/Contestants'
import { CategoryOpenerExtended } from '../../components/CategoryOpener/CategoryOpenerExtended'
import Vod from '../../components/Vod/Vod'
import {
  HorizontalNewsFlashes,
  LiveBlock,
  MinuteLyTopVideo,
  ScriptBlock,
  SpecialRef,
  SpecialRefVotes,
} from '../../components/GridBlocks'
import { Base } from '../../components/Base/Base'
import { Banner } from '../../components/Ads/Banner'
import {
  Advertisers,
  CategoryOpener,
  GridVideo,
  ImageCounter,
  MainStandard,
  MainTextOver,
  MidBoxMobile,
  Opinions,
  Pager,
  Reels,
  Separator,
  Stories,
  TermHeadBlock,
  TimeLineBlock,
} from '../../components/DynamicComponents'
import TimeLineVerticalPlayer from '../../components/TimeLine/BigBrother/TimeLineVerticalPlayer'
import { isStoriesBlock } from '../../types/stories'

export const PageGridItemToComponent = (
  item: PageGridItem,
  pageMeta: IPageMeta,
  position?: number
) => {
  if (isTermHeadBlock(item)) {
    return <TermHeadBlock termHead={item} key={item.term_id} />
  }

  const { grid_id } = item

  if (isStoriesBlock(item)) {
    return <Stories key={grid_id} data={item} />
  }

  if (IsVideoGridComponent(item)) {
    return <GridVideo video={item} key={item.term_id} />
  }

  if (IsImageCounterComponent(item)) {
    return <ImageCounter image_counter={item} />
  }

  if (isMainStandardItem(item)) {
    return <MainStandard mainStandard={item} key={grid_id} />
  }
  if (isMainTextOverItem(item)) {
    return <MainTextOver mainTextOver={item} key={grid_id} />
  }
  if (isLiveBroadcast(item)) {
    return (
      <LiveBroadcast
        liveBroadcast={item}
        key={grid_id}
        isFirst={position === 0}
      />
    )
  }
  if (isLayout3(item)) {
    return (
      <LayoutWithBanner
        postsInBlock={3}
        index={position || 1}
        layout={item}
        key={grid_id}
      />
    )
  }
  if (isLayout4(item)) {
    return <Layout4 layout={item} key={grid_id} />
  }
  if (isLayout6(item)) {
    return <Layout6 layout={item} key={grid_id} />
  }
  if (isLayout7(item)) {
    return (
      <LayoutWithBanner
        postsInBlock={7}
        index={position || 1}
        layout={item}
        key={grid_id}
      />
    )
  }
  if (isMatrix1x4(item)) {
    return <Matrix1x4 matrix={item} key={grid_id} />
  }
  if (isMatrix2x4(item)) {
    return <Matrix2x4 matrix={item} key={grid_id} />
  }
  if (isPublishersComponent(item)) {
    return <Publishers publishers={item} key={grid_id} />
  }
  if (isContestantsComponent(item)) {
    return <Contestants contestants={item} key={grid_id} />
  }
  if (isCategoryOpener(item)) {
    return <CategoryOpener categoryOpener={item} key={grid_id} />
  }
  if (isCategoryOpenerExtended(item)) {
    return <CategoryOpenerExtended categoryOpenerExt={item} key={grid_id} />
  }
  if (isIFrameBlock(item)) {
    return <IFrame iFrame={item} key={grid_id} />
  }
  if (isVod(item)) {
    return <Vod vod={item} key={grid_id} />
  }
  if (isSeparator(item)) {
    return <Separator separator={item} key={grid_id} />
  }
  if (isHorizontalNewsFlashes(item)) {
    return <HorizontalNewsFlashes newsFlashes={item} key={grid_id} />
  }
  if (isSpecialRef(item)) {
    return <SpecialRef specialRef={item} key={grid_id} />
  }
  if (isSpecialRefVotes(item)) {
    return <SpecialRefVotes block={item} key={grid_id} />
  }
  if (isBase(item)) {
    return (
      <Base
        base={item}
        pageType={pageMeta.pageType}
        blockTaboola={pageMeta.ads.block.taboola}
        key={grid_id}
      />
    )
  }
  if (isPager(item)) {
    return item.max_page > 1 ? <Pager pager={item} key={grid_id} /> : null
  }
  if (isBanner(item)) {
    return <Banner banner={item} collapse={false} key={grid_id} />
  }
  if (isOpinion(item)) {
    return <Opinions opinionsAndPosts={item} key={grid_id} />
  }
  if (isTimeline(item)) {
    return <TimeLineBlock {...item} key={grid_id} />
  }
  if (isLiveBlock(item as ILiveVodPageGrid)) {
    return <LiveBlock {...(item as ILiveVodPageGrid)} key={grid_id} />
  }

  if (isAdvertisers(item)) {
    return <Advertisers layout={item} key={grid_id} />
  }
  if (isMidBoxMobile(item)) {
    return <MidBoxMobile key={grid_id} position={position || 1} />
  }
  if (isVerticalBlock(item)) {
    return <Reels key={grid_id} data={item} />
  }

  if (isMinuteLyTopVideoComponent(item)) {
    return <MinuteLyTopVideo data={item} />
  }

  if (IsTerrificComponent(item) || IsMinuteLyVerticalComponent(item)) {
    return <ScriptBlock data={item} />
  }

  if (isTimeLineVerticalPlayerComponent(item)) {
    return <TimeLineVerticalPlayer data={item} />
  }

  // if (isArticleGrid_fl(item)) {
  //   const ArticlesGrid_fl = dynamic(
  //     () => import('./ArticlesGrid/ArticlesGrid_fl')
  //   )
  //   return <ArticlesGrid_fl layout={item} key={grid_id} />
  // }
  // if (isSpecialRefFl(item)) {
  //   return <SpecialRefFl specialRef={item} key={grid_id} />
  // }
  // if (isContestantsFLComponent(item)) {
  //   return <ContestantsFl contestants={item} key={grid_id} />
  // }
  // //Episodes for FaceLift project
  // if (isEpisodesGridFl(item)) {
  //   return <EpisodesGridFl layout={item} key={grid_id} />
  // }
  // //Reels for FaceLift project
  // if (isReelsFl(item)) {
  //   return <ReelsFl layout={item} key={grid_id} />
  // }
  // if (isSeasonFLComponent(item)) {
  //   return <SeasonFL season={item} key={grid_id} />
  // }
  // if (isEpisodesRowFLComponent(item)) {
  //   return <EpisodesRowFL layout={item} key={grid_id} />
  // }
  // if (isPodcastFLComponent(item)) {
  //   return <PodcastFL podcast={item} key={grid_id} />
  // }
  // if (isOpeningBannerFl(item)) {
  //   const OpeningBannerFl = dynamic(
  //     () => import('./OpeningBanner/OpeningBannerFl')
  //   )
  //
  //   return <OpeningBannerFl openingBanner={item} key={grid_id} />
  // }
  // if (isTimelineFl(item)) {
  //   const TimeLineBlockFl = dynamic(
  //     () => import('./GridBlocks/TimeLineBlockFl')
  //   )
  //   return <TimeLineBlockFl {...item} key={grid_id} />
  // }

  return <></>
}
